document.addEventListener('DOMContentLoaded', function() {
    
    // Function to get the value of a query parameter by name
    function getQueryParam(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    // Function to get all UTM parameters from the URL
    function getUtmParams() {
        const urlParams = new URLSearchParams(window.location.search);

        
        const utmParams = {};
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(param => {
            const value = urlParams.get(param);
            if (value) {
                utmParams[param] = value;
            }
        });
        return utmParams;
    }

    // Function to update all links with the gclid and UTM parameters
    function updateLinks(params) {
        const links = document.querySelectorAll('a');
        links.forEach(link => {
            const linkHref = link.href;
            try {
                const url = new URL(linkHref);
                Object.keys(params).forEach(key => {
                    url.searchParams.set(key, params[key]);
                });
                link.href = url.toString();
                console.log(`Updated link: ${link.href}`);
            } catch (e) {
                console.error(`Invalid URL: ${linkHref}`, e);
                // Handle the invalid URL case if needed
            }
        });
    }

    // Function to update all forms with the gclid and UTM parameters
    function updateForms(params) {
        const forms = document.querySelectorAll('form');
        forms.forEach(form => {
            Object.keys(params).forEach(key => {
                let input = form.querySelector(`input[name="${key}"]`);
                if (!input) {
                    input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    form.appendChild(input);
                }
                input.value = params[key];

                // Update form action URL with parameters
                const url = new URL(form.action);
                url.searchParams.set(key, params[key]);
                form.action = url.toString();
            });
            console.log(`Updated form: ${form}`);
        });
    }

    // Function to update all mailto links if UTM parameters are present
    function updateMailtoLinks(params) {
        const mailtoLinks = document.querySelectorAll('a[href^="mailto:sales@enforcergroup.com.au"]');
        mailtoLinks.forEach(link => {
            link.href = link.href.replace('mailto:sales@enforcergroup.com.au', 'mailto:quotes@enforcergroup.com.au');
            link.innerHTML = link.innerHTML.replace('sales@enforcergroup.com.au', 'quotes@enforcergroup.com.au');
            console.log(`Updated mailto link: ${link.href}`);
        });
    }

    // Function to find all items with the class open-popupRequestForm and remove the class and add href of mailto:quotes@enforcergroup.com.au'

    function updatePopupRequestForm() {
        const popupRequestForm = document.querySelectorAll('.open-popupRequestForm');
        popupRequestForm.forEach(link => {
            console.log("Updated PopUp to:" , link);
            link.classList.remove('open-popupRequestForm');
            link.href = 'mailto:quotes@enforcergroup.com.au';
        });
    }

    // Main execution
    window.onload = function() {
        // Main execution
        const gclid = getQueryParam('gclid');
        if (gclid !== null) {
            const utmParams = getUtmParams();
            const params = { ...utmParams, gclid };
    
            console.log(`Parameters: ${JSON.stringify(params)}`);
            updateLinks(params);
            updateForms(params);
            updateMailtoLinks(params);
            // loop to update the popup request form
            setInterval(updatePopupRequestForm, 1000); // call every 1000 milliseconds (1 second)
        }
    };
});

document.addEventListener('DOMContentLoaded', function() {
    // Function to get URL parameters
    function getParameterByName(name) {
        const url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    // Get UTM parameters
    const utmSource = getParameterByName('utm_source');
    const utmMedium = getParameterByName('utm_medium');
    const utmCampaign = getParameterByName('utm_campaign');

    // Function to create hidden input field
    function createHiddenInput(name, value) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `contact[${name}]`;
        input.value = value;
        return input;
    }

    // Get all forms on the page
    const forms = document.querySelectorAll('form');

    // Add hidden fields to each form
    forms.forEach(form => {
        console.log(form);
        console.log(utmSource)
      
        if (utmSource) {
            form.appendChild(createHiddenInput('utm_source', utmSource));
        }
        if (utmMedium) {
            form.appendChild(createHiddenInput('utm_medium', utmMedium));
        }
        if (utmCampaign) {
            form.appendChild(createHiddenInput('utm_campaign', utmCampaign));
        }

      
      });
  

  
  
});

jQuery(document).ready(function () {
let utmSource = localStorage.getItem('utm_source');
let utmMedium = localStorage.getItem('utm_medium');
let utmCampaign = localStorage.getItem('utm_campaign');

    console.log('Retrieved UTM Source:', utmSource);
    console.log('Retrieved UTM Medium:', utmMedium);
    console.log('Retrieved UTM Campaign:', utmCampaign);
  
    jQuery('.form').on('submit', function (e) {
    var formData = jQuery(this).serializeArray();
    localStorage.setItem('contactFormData', JSON.stringify(formData));
    var savedFormData = localStorage.getItem('contactFormData');
    if (savedFormData) {
      savedFormData = JSON.parse(savedFormData);
      let utmSource = '';
      let utmMedium = '';
      let utmCampaign = '';
    savedFormData.forEach(function (field) {
    if (field.name === 'utm_source') {
        utmSource = field.value;
        localStorage.setItem('utm_source', utmSource);
    }
    if (field.name === 'utm_medium') {
        utmMedium = field.value;
        localStorage.setItem('utm_medium', utmMedium);
    }
    if (field.name === 'utm_campaign') {
        utmCampaign = field.value;
        localStorage.setItem('utm_campaign', utmCampaign);
    }
});
      // Log the UTM values
      console.log('UTM Source:', utmSource);
      console.log('UTM Medium:', utmMedium);
      console.log('UTM Campaign:', utmCampaign);
    } else {
      console.log('No saved form data found in local storage.');
    }
  });
});